export default __webpack_public_path__ + "model_training_logo.7bc1059e.png";